module.exports = __webpack_public_path__ + "static/media/noti--white.41dcd14d.svg";